/**
 * Current user permission holder.
 *
 * Populated by AuthProvider once `/api/v1/me` resolves — same pattern as
 * currentUser.ts. Consumed by code paths that need a permission check outside
 * the React tree, where usePermissions() is unavailable. Today that is the
 * app-level `sendQE` execution listener in QueryEditorProvider, which mounts
 * above AuthProvider.
 *
 * Fails CLOSED: until the mirror is populated, canCurrentUser() denies.
 * AppShell blocks page render until /me resolves, so interactive paths never
 * race this in practice; the fail-closed default only covers programmatic
 * emits fired before auth settles.
 */
import { checkPermission } from '@/hooks/usePermissions';

interface MirroredPermissions {
  global: Record<string, string[]> | undefined;
  isAdmin: boolean;
}

let current: MirroredPermissions | null = null;

export function setCurrentUserPermissions(perms: MirroredPermissions | null): void {
  current = perms;
}

export function canCurrentUser(resource: string, action: string): boolean {
  if (!current) return false;
  if (current.isAdmin) return true;
  return checkPermission(current.global, resource, action);
}
